import { cn } from "@/lib/utils";
import { Scribbles } from "@somethings-ui/core/assets";
import { colorsV2 } from "@somethings-ui/core";
import type { CSSProperties, ReactNode } from "react";

const PERIWINKLE_DARK = "#2F2D82";

interface PeriwinkleCardProps {
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
  variant?: "highlight" | "solid";
  fullBleedOverlay?: boolean;
}

export function PeriwinkleCard({
  className,
  style,
  children,
  variant = "solid",
  fullBleedOverlay = false,
}: PeriwinkleCardProps) {
  const isHighlight = variant === "highlight";
  return (
    <div
      className={cn("relative overflow-hidden", className)}
      style={{
        backgroundColor: isHighlight ? PERIWINKLE_DARK : colorsV2.brand.periwinkle,
        ...style,
      }}
    >
      <img
        src={Scribbles.purpleCloudTilted}
        alt=""
        aria-hidden
        className={cn(
          "pointer-events-none absolute select-none",
          fullBleedOverlay ? "inset-0 h-full w-full object-cover" : "",
        )}
        style={
          fullBleedOverlay
            ? { opacity: isHighlight ? 0.95 : 0.6 }
            : {
                width: "200%",
                height: "200%",
                top: "-100%",
                transformOrigin: "center",
                objectFit: "cover",
                opacity: isHighlight ? 0.95 : 0.6,
              }
        }
      />
      <div className="relative h-full">{children}</div>
    </div>
  );
}
